import { Checkbox } from 'semantic-ui-react';
import Label from 'components/Label/Label';
import './is-marketplace-filter.scss';

export default function IsMarketplaceFilter({ checked, onToggle = () => {} }) {
  return (
    <div className="is-marketplace-filter">
      <Label small>Solo Marketplace</Label>
      <Checkbox toggle checked={checked} onChange={onToggle} />
    </div>
  );
}
